module.exports = __webpack_public_path__ + "media/images/lp/support-ashinaga2-sp-23ec1360387f14f0ee1c0ad7263389b9.png";